import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'components/core/Link';
import { Image } from 'components/core/Image';

import './PromoCard.scss';

function PromoCard({ href, src, openNewTab = true, lazyLoad = true }) {
	return (
		<div className="promo-ad-card">
			<Link
				hideBorder
				href={href}
				target={openNewTab ? '_blank' : '_self'}
				rel="noopener noreferrer"
			>
				<Image
					src={src}
					lazyLoad={lazyLoad}
				/>
			</Link>
		</div>
	);
}

PromoCard.propTypes = {
	href: PropTypes.string.isRequired,
	src: PropTypes.string.isRequired,
	openNewTab: PropTypes.bool,
	lazyLoad: PropTypes.bool
};

export default PromoCard;
